import { BootstrapEntity } from "../../services/Bootstrap/bootstrap.entity";

const FieldKeys = {
  TenantInfo: "tenantInfo",
};

export class LocalStorage {
  static getTenantInfo(): BootstrapEntity | undefined {
    const tenantInfo = window.localStorage.getItem(FieldKeys.TenantInfo) || "";
    if (tenantInfo === "" || tenantInfo === undefined) {
      return undefined;
    }
    const tenantInfoJson = JSON.parse(tenantInfo) as BootstrapEntity;
    return tenantInfoJson;
  }
  static setTenantInfo(info: BootstrapEntity) {
    window.localStorage.setItem(FieldKeys.TenantInfo, JSON.stringify(info));
  }

  static getShowHideColumns<T>(key: string) {
    const columns = window.localStorage.getItem(key);
    if (!columns) {
      return undefined;
    }
    return JSON.parse(columns) as T;
  }

  static setShowHideColumns<T>(key: string, columns: T) {
    window.localStorage.setItem(key, JSON.stringify(columns));
  }
}
